import { User } from '@models/User'
import { Tokens } from '@models/Tokens'

export const createDefaultMfaState = () => ({
	required: false,
	enrolled: false,
	enabled: false,
	gracePeriodEndsAt: null,
	enforcementRequired: false,
	fetched: false
})

// Transient Cognito challenge session — lives only in memory (never in the
// URL, localStorage or logs) and is cleared after the challenge completes.
export const createDefaultMfaChallenge = () => ({
	sessionKey: null,
	email: null
})

export default () => ({
	isValidating: false,
	authenticated: false,
	selectingDepartmentId: null,
	mfa: createDefaultMfaState(),
	mfaChallenge: createDefaultMfaChallenge(),
	user: new User(),
	tokens: new Tokens({
		accessToken: localStorage.getItem(process.env.VUE_APP_ACCESS_TOKEN_NAME),
		idToken: localStorage.getItem(process.env.VUE_APP_ID_TOKEN_NAME),
		refreshToken: localStorage.getItem(process.env.VUE_APP_REFRESH_TOKEN_NAME)
	})
})
